export var NO_SCENARIO_FOUND = 'NO_SCENARIO_FOUND';
export var SSR_HOST = 'www.wix.com';
export var ORIGINAL_URL_HEADER = 'x-wix-metro-original-url';
export var ORIGINAL_HOST_HEADER = 'x-wix-metro-original-host';
//# sourceMappingURL=constants.js.map